import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  contentLeft: PropTypes.node,
  contentRight: PropTypes.node,
};

const DesignEditorAuxiliaryControlBar = ({
  className,
  contentLeft,
  contentRight,
}) => {
  const classes = classNames({
    'design-editor-auxiliary-control-bar': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {contentLeft && (
        <div className="design-editor-auxiliary-control-bar-left">
          {contentLeft}
        </div>
      )}
      {contentRight && (
        <div className="design-editor-auxiliary-control-bar-right">
          {contentRight}
        </div>
      )}
    </div>
  );
};

DesignEditorAuxiliaryControlBar.propTypes = propTypes;

export default DesignEditorAuxiliaryControlBar;
